import React from "react";

const LoginIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 0H16V16H4V10.1818H4.8V15.2727H15.2V0.727273H4.8V6.54545H4V0ZM9.8472 8.72727L7.728 10.6531L8.2936 11.1673L11.4056 8.33818L8.34 5.55055L7.7744 6.06473L9.9024 8H0V8.72727H9.8472Z"
        fill="#3F3F3F"
      />
    </svg>
  );
};

export default LoginIcon;
